import React, { createContext } from 'react';

const BrandContext = createContext({ brands: [] });

export default BrandContext;
